/**
 * Url parsing library
 *
 */


/**
 * uses the browser to parse the url
 *
 * @param url
 * @returns {{href, protocol, host, hostname, port, pathname, search, hash, origin}}
 */
export function parseUrl(url) {

  let a = document.createElement('a');

  a.href = url;

  let {href, protocol, host, hostname, port, pathname, search, hash, origin} = a;

  // fix port
  if(port === '0') port = '';

  // fix origin
  if (!origin || origin === 'null')
    origin = getOrigin(a);

  return {href, protocol, host, hostname, port, pathname, search, hash, origin};
}

/**
 * Parse a querstring and extracts params as a simple map
 *
 * @param queryString
 * @returns {null}
 */
export function parseQueryString(search) {

  let params = Object.create(null);

  if (!search) return params;

  if (search.indexOf('?') == 0 || search.indexOf('#') == 0) {
    search = search.substr(1);
  }

  let pairs = search.split('&');

  pairs.forEach(p =>{

    let [k,v] = p.split('=');

    params[decodeURIComponent(k)] = v?decodeURIComponent(v): undefined;
  });

  return params;
}

/**
 * this encodes a query object as q query String
 * @param query
 * @returns {*}
 */
export function encodeQueryString(query){

  return Object.keys(query).map((k)=> encodeURIComponent(k) + '=' + encodeURIComponent(query[k])).join('&');
}


// get the origin of a url object
function getOrigin({protocol, href, host}) {

  if(protocol === 'data:' || !host)
    return href;

  return protocol + '//' + host;
}